module.exports = __webpack_public_path__ + "static/media/qrmed.f0bb2880.jpg";